<template>
  <section>
    <el-row class="selectRow">
      <el-col >
        <el-row :gutter="10">
        	<el-button size="medium" type="primary" @click="goBack">返回</el-button>
        	<el-select class="xs24" v-model="issued_app_id" filterable  clearable placeholder="请输入发行游戏名称">
	        	<el-option v-for="(item,i) in PlacementList" :key="item.name" :label="item.name" :value="item.issued_app_id"></el-option>
		      </el-select>
         	 <el-button size="medium" type="primary" @click="getList()">刷新</el-button>

         
           
        </el-row>
      </el-col>
    </el-row>
    <el-row class="statusRow">
      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
      <!--<el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
       <el-button size="medium" type="primary" @click="planConfig">同步线上配置</el-button>
    </el-row>
    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      stripe
      row-key="id"
      @selection-change="select"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="ID" width="50px" align="center"></el-table-column>
     
      <el-table-column prop="type_name" label="广告位名称" align="left" min-width="120px">
      	 <template slot-scope="scope" >
      	 	 <div v-if="scope.row.isAdd">
      	 	 	<el-select class="xs24" v-model="plist[scope.$index].type"  filterable  clearable placeholder="请选择广告位名称">
		        	<el-option  v-for="(v,i) in config" :key="v[0]" :label="v[0]" :value="v[1]"></el-option>
			      </el-select>
      	 	 </div>
      	 	 <div v-else>{{scope.row.type_name}}</div>
      	 </template>
      </el-table-column>
      <el-table-column prop="type" label="广告位标识" align="left" min-width="120px">
      	 <template slot-scope="scope" >
      	 	 <div v-if="scope.row.isAdd">
      	 	 	{{scope.row.type}}
      	 	 </div>
      	 	 <div v-else>{{scope.row.type}}</div>
      	 </template>
      </el-table-column>
      <el-table-column prop="update_time" label="更新时间" align="center">
      	
      </el-table-column>
       <el-table-column prop="status" label="广告位状态" align="center">
       	 <template slot-scope="scope" >
      	 	 <div v-if="scope.row.isAdd"></div>
      	 	 <div v-else>{{scope.row.status=='1'?'正常':'禁用'}}</div>
      	 </template>
      </el-table-column>
      <el-table-column prop="status" label="操作" align="center">
        <template slot-scope="scope">
        	<el-button  size="mini" type="primary" v-if="scope.row.isAdd" @click="SaveSpace(scope.$index)">确认添加</el-button>
          <el-button
          	v-if="!scope.row.isAdd" 
            size="mini"
            :type="scope.row.status=='1'?'success':'danger'"
            @click="changeStatus(true,scope.row)"
          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
          <el-button size="mini" v-if="!scope.row.isAdd" type="text" @click="$router.push({name:'广告位日志',params:{index_id:scope.row.id},query:{type:'space'}})">更新日志</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="pageRow">
      <el-pagination
        class="pagination"
        @size-change="SizeChange"
        @current-change="CurrentChange"
        :current-page.sync="pdata.page"
        :page-sizes="[20, 40, 60, 80]"
        :page-size="pdata.perpage"
        background
        layout="sizes, prev, pager, next, jumper"
        :total="pdata.perpage*maxPage"
      ></el-pagination>
    </div>
   
   
  </section>
</template>

<script>
import { sadlist, sadstatus, saddad, seditad ,sclog ,getPlacementList,pPlanConfig} from "../../api/api";

export default {
  data() {
    return {
      rules: {
        type: [
          { required: true, message: "请选择广告位类型", trigger: "change" }
        ],
        device: [
          { required: true, message: "请选择广告位系统", trigger: "change" }
        ],
        issued_app_id: [
          { required: true, message: "请选择小程序", trigger: "blur" }
        ]
      },
      pdata: {
        page: 1,
        perpage: 20,
        status: "",
        kw: "",
        type: "",
        sort_field: "",
        sort_by: "",
      },
      issued_app_id:"",
      plist: [],
      PlacementList:[],
      maxPage: 1,
      config: [],
      editDialog: false,


      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [],

    };
  },
  watch: {
    'issued_app_id': {
      handler(n, o) {
        this.$router.push({name:'广告位',params:{issued_app_id:this.issued_app_id}})
        this.getList();
        
      },
      deep: true
    },
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  methods: {
  	  planConfig(){
  	 	//配置静态化
  	 	  this.$confirm('即将同步线上配置，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
       }).then(() => {
       		pPlanConfig({issued_app_id:this.issued_app_id}, this.$cookie.getCookie("login")).then(res => {
		        if (res.code == 200) {
		          this.$message({ message: "同步成功", type: "success" });
		          this.getList();
		          
		        }
		        else{
		        	this.$message.error(res.msg);
		        }
		      });
       })
 
  	 },
			goBack(){
				this.$router.go(-1);
			},
  	 openDealy(id) {
  	 	var p = 'type=space&index_id='+id;
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      var p = "issued_app_id="+this.issued_app_id+'&';
      for (var k in this.pdata) {
        // if (this.pdata[k]) p += "&" + k + "=" + this.pdata[k];
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      sadlist(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.plist = res.data.list;
          	this.maxPage = res.data.max_page;
        	}
        	else{
        		this.plist =[];
        		this.maxPage=1;
        	}
          
        }
      });
    },
    getPlacements(){
    	getPlacementList('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.PlacementList = res.data.list;
          
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_space_type;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
   
    search() {
      // 有问题;
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },

    editProduct(d) {
      this.editDialog = true;
      this.form = JSON.parse(JSON.stringify(d));
      this.form.space_id = this.form.id;
      delete this.form.start_time;
    	delete this.form.end_time;
      this.isAdd = false;
    },
    changeStatus(isSingle, s) {
	      if (!isSingle && this.selectProduct.length == 0) {
	        this.$message.error("请先选择需要批量操作的数据");
	        return;
	      }
	      if (isSingle) {
	        this.cP.index_id = s.id;
	        this.cP.status = s.status == 1 ? "0" : "1";
	      } else {
	        this.cP.status = s;
	      }
	
	    this.$confirm(this.cP.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
	      sadstatus(this.cP, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.getList();
	          this.$message({ message: this.cP.log + "成功", type: "success" });
	        }
	      });

      });
    	
 
      
    },
    addProduct() {
    	debugger;
    	if(this.plist[0]!=undefined&&this.plist[0].isAdd){
    		this.$message.error('请先保存再增加更多');
    		return false;
    	}
    	this.plist.unshift({type:"",type_name:"",update_time:"",isAdd:'true'});
    },	
    SaveSpace(index){
    	if(this.plist[index].type==''){
    		this.$message.error('广告位名称不能为空');
    		return false;
    	}
    	saddad({issued_app_id: this.issued_app_id,  type: this.plist[index].type}, this.$cookie.getCookie("login")).then(res => {
              if (res.code == 200) {
                this.$message({ message: "新增广告位成功", type: "success" });
                this.getList();
                
              } else {
                this.$message.error(res.msg);
              }
            });
    },

    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    }
  },

  mounted() {
  	this.issued_app_id = this.$route.params.issued_app_id;
    this.getList();
    this.getPlacements();
    this.getConfig();
  }
};
</script>




// WEBPACK FOOTER //
// ADbanner.vue?14040982